"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../../helpers");

var _styles = _interopRequireDefault(require("./styles"));

var Button = _styles["default"].Button;

var postAddToCart = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var item, contractId, config, state, env, result;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            item = _ref.item, contractId = _ref.contractId, config = _ref.config, state = _ref.state, env = _ref.env;
            (0, _helpers.postAnalytics)('item-atc', {
              item: item,
              contractId: contractId,
              store: config.title
            }, env);
            state.setAdding(true);
            console.log("ITEM DATA", "item=", item, "contractId=", contractId, state, env);
            _context.next = 6;
            return (0, _helpers.addToCart)({
              item: item,
              contractId: contractId,
              state: state,
              env: env
            });

          case 6:
            result = _context.sent;
            if (env.onATC) env.onATC(result);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function postAddToCart(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var ATCButton = function ATCButton(props) {
  var className = props.className,
      height = props.height,
      width = props.width,
      item = props.item,
      config = props.config,
      contractId = props.contractId,
      env = props.env;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      adding = _useState2[0],
      setAdding = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      added = _useState4[0],
      setAdded = _useState4[1];

  var state = {
    adding: adding,
    setAdding: setAdding,
    added: added,
    setAdded: setAdded
  };
  (0, _react.useEffect)(function () {
    if (added) {
      setTimeout(function () {
        setAdded(false);
      }, 3000);
    }
  }, [added]);
  return /*#__PURE__*/_react["default"].createElement(Button, {
    className: "atc-button ".concat(className ? className : ''),
    "data-aurora-automation": "store-atc-button",
    height: height,
    width: width,
    onClick: function onClick() {
      return postAddToCart({
        item: item,
        contractId: contractId,
        config: config,
        state: state,
        env: env
      });
    },
    added: added
  }, !added && !adding && 'Add to Cart', adding && /*#__PURE__*/_react["default"].createElement("div", {
    id: "dots-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "dots dot-1"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "dots dot-2"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "dots dot-3"
  })), added && 'Added!');
};

var _default = ATCButton;
exports["default"] = _default;